import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import fun from "../fun";
import base64_encode from "utils/base64_encode";
import Fun from "../fun";
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // api 的 base_url
  timeout: 500000,
  // 请求超时
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});
service.interceptors.request.use(function (config) {
  // config.baseURL = process.env.VUE_APP_BASE_API;

  // 每次请求都获取最新的PHPSESSID
  // let PHPSESSID = fun.getCookie("PHPSESSID");
  var tid = fun.getKey("tid");
  var requestPath = config.url;
  config.url = requestPath;
  var access_token = fun.getKey("access_token") || localStorage.getItem("access_token");
  // 添加PHPSESSID到Authorization头，使用Bearer格式
  if (access_token) {
    config.headers["Authorization"] = "Bearer ".concat(access_token);
  }
  // else if (PHPSESSID) {
  //     config.headers["Authorization"] = `Bearer ${PHPSESSID}`;
  // }
  if (tid) {
    config.headers["Tid"] = "".concat(tid);
  }
  // 添加时间戳防止缓存
  if (config.method === "get") {
    config.params = _objectSpread(_objectSpread({}, config.params), {}, {
      _t: Date.now()
    });
  }
  // 添加loading控制
  if (config.loading) {
    _Toast.loading({
      message: config.loadingText || "加载中...",
      forbidClick: true,
      duration: 0
    });
    config._loadingInstance = _Toast; // 保存实例
  }
  return config;
}, function (error) {
  Promise.reject(error);
});
service.interceptors.response.use(function (response) {
  // console.log(response, "newrequest");
  if (response.data.code == 0) {
    return response.data;
  } else if (response.data.code === 10001 || response.data.code === 10002) {
    return response.data;
  } else if (response.data.code === 401 || response.data.msg && response.data.msg.includes("权限")) {
    // 权限问题，直接提示用户重新登录
    var errorMsg = "登录已过期，请前往个人中心登录";
    _Toast(errorMsg);
    // 可以在这里添加跳转到登录页的逻辑
    // window.location.href = Fun.getSiteRoot() + "/addons/yun_shop/#/AuthorizedLogin?i=1&yz_redirect=" + base64_encode(document.location.href) + "&type=5&mid=" + Fun.getKeyByMid();
    return Promise.reject(response.data);
  } else {
    _Toast(response.data.msg);
    return Promise.reject(response.data);
  }
}, function (error) {
  console.log(error.response);
  return Promise.reject(error.response);
});
export default service;